module.exports = __webpack_public_path__ + "img/P150T_weapon_28.ceae997d.png";